import { useQuery } from '@tanstack/react-query';
import { useApi } from 'contexts/ApiContext';

import type api from 'api';
import type { QueryOptionsFor } from 'hooks/api/types';
import useProjectRoute from 'hooks/useProjectRoute';

interface VoiceOptions {
  options?: QueryOptionsFor<typeof api.getVoiceOptions>;
}

export const useVoiceOptions = ({ options }: VoiceOptions = {}) => {
  const api = useApi();
  const { accountId, projectId } = useProjectRoute();

  return useQuery(
    [accountId, projectId, 'voices'],
    () => api.methods.getVoiceOptions(accountId, projectId),
    options,
  );
};
